export const useAppVersionAccess = () => {
	const isAllowedAppVersionAccess = (email: string, isSuperAdmin: boolean) =>
		ALLOWED_APP_VERSION_EMAILS.includes(email) && isSuperAdmin

	return {
		isAllowedAppVersionAccess,
	}
}
